import { render, staticRenderFns } from "./DocTitle.vue?vue&type=template&id=353cd53b&"
import script from "./DocTitle.vue?vue&type=script&lang=js&"
export * from "./DocTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports